// Angular
import { Injectable } from '@angular/core';

// Services
import { OAuthService } from './../o-auth';
import { Router } from "@angular/router";
import { ApiService } from './../../services/api';

@Injectable()

export class PremiumGuardService {
    private club: any;
    constructor(private oAuthService: OAuthService, private router: Router, private apiService: ApiService) { }

    canActivate(): Promise<boolean> {
        return new Promise(resolve => {
            return resolve(true)
            // this.club = this.oAuthService.getClub();
            // this.apiService.object(`/users/${this.club.$key}`)
            //     .then(club => {
            //         console.log(club)
            //         const now = new Date();
            //         this.oAuthService.setClub(club)

            //         // if (club['subscription']) {
            //         //     if ((club['subscription'] * 1000) > now.getTime()) {
            //         //         resolve(true);
            //         //     } else {
            //         //         alert("Your subscription plan is expired.")
            //         //         this.router.navigate(["/dashboard"]);
            //         //         resolve(false);
            //         //     }
            //         // } else {
            //         //     if (club['trial']) {
            //         //         if ((club['trial'] * 1000) > now.getTime()) {
            //         //             resolve(true);
            //         //         } else {
            //         //             alert("Your trial period is expired.")
            //         //             this.router.navigate(["/dashboard"]);
            //         //             resolve(false);
            //         //         }
            //         //     } else {
            //         //         alert("Your subscription plan is expired.")

            //         //         this.router.navigate(["/dashboard"]);
            //         //         resolve(false);

            //         //     }
            //         // }
            //     })

        });
    }
}
         // if(!club['subscription'])
                    // {
                    //     if(club['trial']){
                    //         if(club['trial'] < now.getTime())
                    //         {
                    //             alert("Your trial period is expired.")

                    //             this.router.navigate(["/dashboard"]);
                    //             resolve(false);
                    //         }
                    //         else
                    //             resolve(true);
                    //     }

                    // }
                    // else
                    // {

                    //         console.log(club['subscription'])
                    //         if(club['subscription'] < now.getTime())
                    //         {
                    //             alert("Your subscription plan is expired.")

                    //             this.router.navigate(["/dashboard"]);
                    //             resolve(false);
                    //         }
                    //         else
                    //             resolve(true);


                    // }


// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/services/premium-guard/premium-guard.service.ts